<template>
  <div>
    <!--BEGIN DROPDOWN Custom-->
    <div class="form-group" style="margin-bottom:0px;">
      <div style="width: 100%;" class="dropdown">
        <b-form-input
          @click="showAdvanceFilter"
          :placeholder="'Chọn Gói'"
          :value="itemSelected"
          required
          class="form-control"
          type="text"
          data-toggle="dropdown"
          readonly
          style="background:white;cursor: pointer;"
        />
        <div
          v-if="isShowAdvanceFilter"
          v-show="isShowAdvanceFilter"
          v-click-outside="outside"
          @click="inside"
          class="dropdown-menu dropdown"
          :style="isOnlyShowInputPackage ? 'width: 400px;z-index:1;' : 'margin-left:15px;width:100%;z-index:1;'"
        >
          <div class="dropdown-title">
            <label
              style=" display: block;
                          text-align: center;
                          line-height: 80%;"
              for="selecttype"
              class="control-label"
            >{{$t('sidebar.servicemanagement.package')}}</label>
            <button
              class="dropdown-title-button dropdown-menu-close"
              type="button"
              @click="closeAdvanceFilter"
            >
              <i aria-hidden="true" data-hidden="true" class="fa fa-times dropdown-menu-close-icon"></i>
            </button>
          </div>
          <!-- Content -->
          <div class="dropdown-content" style="margin-top:20px;">
            <ul>
              <div class="box-body table-responsive no-padding">
                <table class="table table-hover" style="width:100%;">
                  <tbody>
                    <tr>
                      <th>{{$t('service.package.pkg_name')}}</th>
                      <th>{{$t('accounting_home_liability.cash')}}</th>
                      <th>{{$t('service.package.pkg_type')}}</th>
                    </tr>
                    <tr
                      v-for="itemtype in filteredItemTypeItems"
                      :key="itemtype.pkg_name"
                      @click="selectItem(itemtype)"
                      style="cursor: pointer"
                    >
                      <td>{{itemtype.pkg_name}}</td>
                      <td>{{itemtype.price}}</td>
                      <td style="text-align: center;">{{itemtype.packageType}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- END DROPDOWN Custom-->

    <!-- Dịch Vụ Cố Định (1 Tháng) -->
      <div v-if="!isOnlyShowInputPackage" class="box box-success box-solid" style="margin-top: 20px;width: 100%;">
        <div class="box-header with-border">
          <h3 class="box-title">{{$t('service.package.fixed_service')}}</h3>
        </div>
        <!-- /.box-header -->
        <div class="box-body" style>
          <div v-if="pkg_tmpl.package_onemonth_elements.length == 0">{{$t('service.package.not_found_service')}}</div>
            <div v-for="(item, index) in pkg_tmpl.package_onemonth_elements" :key="index">
              <div class="row">
                <span class="col-md-6">{{item.name}}</span>
                <span class="col-md-6">
                  <span class="badge bg-green pull-right">{{f_formatNumber(f_calculatorPriceService(item.price, item.vat))}} VNĐ</span>
                </span>
              </div>
          </div>
          <div></div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- end - Dịch Vụ Cố Định (1 Tháng) -->

      <!-- begin - Chi Tiết Dịch Vụ -->
      <div v-if="!isOnlyShowInputPackage" class="box box-warning box-solid" >
        <div class="box-header with-border">
          <h3 class="box-title">{{$t('service.package.pkg_other_details')}}</h3>
        </div>
        <!-- /.box-header -->
        <div class="box-body" style>
          <div><textarea disabled class="form-control" rows="5" v-model="pkg_tmpl.pkg_other_details"></textarea></div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- end - Chi Tiết Dịch Vụ -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import utils from '@/lib/utils'

export default {
  name: "SelectOptionPackage",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    apartmentId: {
      type: Number,
      default() {
        return 0;
      }
    },
    packageId: {
      type: Number,
      default() {
        return 0;
      }
    },
    isOnlyShowInputPackage: {
      type: Boolean,
      default() {
        return false
      }
    },
    row: {
      type: Object,
      default() {
        return null
      }
    },
    bedroomCount: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      data_list: null,
      isShowAdvanceFilter: false,
      isShowNewItemType: false,
      number_bedrooms: null,
      filteredItemTypeItems: [],
      itemSelected: null,
      // all package in select box
      pkg_templates: [],
      // all package get from db
      pkg_templates_data: [],
      // package current
      pkg_template_data: {
        id: 0
      },
      pkg_tmpl: {
        package_onemonth_elements: [],
        package_oncetime_elements: [],
        pkg_other_details : ""
      },
      emitPackage: true
    };
  },
  watch: {
    apartmentId: function() {
      if (parseInt(this.apartmentId) !== 0) {
        this.getAptDetails(this.apartmentId)
      }
    },
    packageId: function() {
      if (parseInt(this.packageId) !== 0) {
        this.pkg_template_data.id = this.packageId
        this.emitPackage = false
        if (parseInt(this.apartmentId) !== 0) {
          this.getAptDetails(this.apartmentId)
        }
      }
    },
    APARTMENT_DETAIL_DATA: function() {
      let number_bedrooms = !utils.isNull(
        this.APARTMENT_DETAIL_DATA.bedroom_count
      )
        ? this.APARTMENT_DETAIL_DATA.bedroom_count
        : 0;
      let filter = {
        params: {
          bedrooms: this.bedroomCount != 0 ? this.bedroomCount : number_bedrooms
        }
      };
      this.getPackages(filter)
    }
  },
  computed: {
    ...mapGetters([
      "APARTMENT_DETAIL_DATA"
    ])
  },
  methods: {
    ...mapActions("packageModule", [
      "GET_PACKAGE_OPTIONS"
    ]),
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_DETAIL"
    ]),
    getPackages: function(filter) {
      this.GET_PACKAGE_OPTIONS({data: filter})
        .then(
          function(res) {
            let pkg_templates_data = res.data;
            let pkg_templates = [];
            if (pkg_templates_data.length == 0) {
              let item = {
                id: -1,
                pkg_name: this.$t("apartmentbookings.no_eligible_packages")
              };
              pkg_templates.push(item);
            } else {
              pkg_templates_data.forEach(v => {
                // Check and get default
                if (v.id == this.packageId) {
                    this.itemSelected = v.pkg_name
                }
                let item = {
                  id: v.id,
                  pkg_name: v.pkg_name,
                  packageType: v.payment_duration_factor == 1 ? 'Tháng' : (v.payment_duration_factor == 2 ? 'Tuần' : 'Ngày'),
                  price: v.package_elements.length != 0 ? utils.formatNumber(v.package_elements[0].service_details.price) : 0
                };
                pkg_templates.push(item);
              });
            }
            // set all package for select box
            this.data_list = pkg_templates;
            // set all package get form db
            this.pkg_templates_data = pkg_templates_data;
            if (parseInt(this.packageId) !== 0) {
              this.pkg_template_data.id = this.packageId
              this.onSelectPackage()
            }
            // Filtered
            let data = [];
            let filterKey = this.strSearch && this.strSearch.toLowerCase();
            if (filterKey) {
              data = this.data_list.filter(function(row) {
                return Object.keys(row).some(function(key) {
                  return (
                    String(row[key])
                      .toLowerCase()
                      .indexOf(filterKey) > -1
                  );
                });
              });
              this.data_list = data;
            }
            this.filteredItemTypeItems = this.data_list
          }.bind(this)
        )
        .catch(
          function(error) {
            let item = {
              id: -1,
              pkg_name: this.$t("apartmentbookings.no_eligible_packages")
            };
            this.data_list.push(item);
          }.bind(this)
        );
    },
    getAptDetails: function(apt_id) {
      const data = { id: apt_id }
      this.GET_APARTMENT_DETAIL(data)
        .then(function(res) {})
        .catch(function(error) {
          let item = {
            id: -1,
            pkg_name: this.$t("apartmentbookings.no_eligible_packages")
          };
          pkg_templates.push(item);
        });
    },
    showAdvanceFilter: function(val) {
      this.isShowAdvanceFilter = true;
      this.opened = true;
    },
    outside: function(e) {
      if (this.opened) {
        this.opened = false;
      } else {
        this.isShowAdvanceFilter = false;
        this.isShowNewItemType = false;
      }
    },
    inside: function(e) {
      if (this.opened) {
        this.isShowNewItemType
          ? (this.isShowAdvanceFilter = false)
          : (this.isShowAdvanceFilter = true);
      }
    },
    closeAdvanceFilter: function(e) {
      this.opened = false;
      this.isShowAdvanceFilter = false;
    },
    selectItem: function(item) {
      this.itemSelected = item.pkg_name;
      this.pkg_template_data.id = item.id
      this.emitPackage = true
      this.onSelectPackage()
      this.outside()
    },
    setNoItemType: function(value) {
      this.itemType = 0;
    },
    // calcalator price service (price, vat)
    f_calculatorPriceService: function(price, vat){
      let pricePercent = Math.round((price * vat) / 100)
      return price + pricePercent
    },
    // format number
    f_formatNumber: function(n){
      return utils.formatNumber(n)
    },
    onSelectPackage: function() {
      // search info package by pkg id (this.pkg_template_data.id) in this.pkg_templates_data
      // return object info package
      let pkg_template_filter = this.pkg_templates_data.filter(
        item => item.id == this.pkg_template_data.id
      )
      if (pkg_template_filter.length !== 0) {
        let pkg_template_data = pkg_template_filter[0]
        this.pkg_tmpl.pkg_other_details = pkg_template_data.pkg_other_details
        // get package_onemonth_elements: Fixed service (1 Month)
        // get package_oncetime_elements: Non fixed service(1 Times)
        let package_onemonth_elements = [];
        let package_oncetime_elements = [];
        pkg_template_data.package_elements.forEach(v => {
          let details = v.service_details;
          let priceAfterVAT = this.f_calculatorPriceService(details.price, details.vat)
          let item = {
            service: v.service,
            name: details.name,
            price: details.price,
            vat: details.vat,
            feegroup: details.feegroup,
            priceAfterVAT: priceAfterVAT,
            payment_duration_factor: pkg_template_data.payment_duration_factor,
            other_details: pkg_template_data.pkg_other_details
          };
          if (details.feegroup === 1) {
            package_onemonth_elements.push(item);
          } else {
            package_oncetime_elements.push(item);
          }
        });
        // set Fixed service (1 Month)
        this.pkg_tmpl.package_onemonth_elements = package_onemonth_elements;
        // set Non fixed service(1 Times)
        this.pkg_tmpl.package_oncetime_elements = package_oncetime_elements;
        if (this.emitPackage) {
          this.$emit("clickOnItem", this.pkg_template_data, this.row);
          this.$emit("package-onemonth-elements", this.pkg_tmpl.package_onemonth_elements, this.row);
        }
        this.$emit("package-current-elements", this.pkg_tmpl.package_onemonth_elements, this.row);
      }
    }
  },
  mounted() {
    if (parseInt(this.apartmentId) !== 0) {
      this.getAptDetails(this.apartmentId)
    }
  },
  directives: {
    "click-outside": {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          // let warn = `[Vue-click-outside:] provided expression '${
          //   binding.expression
          // }' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }
          //console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.dropdown .dropdown-menu,
.dropdown .dropdown-menu-nav {
  transform: translateY(0);
  display: block;
  min-height: 40px;
  max-height: 312px;
  overflow-y: auto;
  // z-index: 300;
  margin-top: 4px;
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 400;
  padding: 8px 0;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.dropdown-menu-labels .dropdown-content {
  max-height: 135px;
}
.dropdown-menu .divider,
.dropdown-menu-nav .divider {
  height: 1px;
  margin: 4px 0;
  padding: 0;
  background-color: #dfdfdf;
}

.dropdown-content {
  max-height: 252px;
  overflow-y: auto;
}

.dropdown-menu ul,
.dropdown-menu-nav ul {
  margin: 0;
  padding: 0;
}
ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}
.dropdown-menu li,
.dropdown-menu-nav li {
  display: block;
  text-align: left;
  list-style: none;
  padding: 0 1px;
}

.dropdown-menu li a,
.dropdown-menu li button,
.dropdown-menu li .menu-item,
.dropdown-menu-nav li a,
.dropdown-menu-nav li button,
.dropdown-menu-nav li .menu-item {
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  display: block;
  font-weight: 400;
  position: relative;
  padding: 8px 12px;
  color: #2e2e2e;
  line-height: 16px;
  white-space: normal;
  overflow: hidden;
  text-align: left;
  width: 98%;
}

.dropdown-menu a,
.dropdown-menu button,
.dropdown-menu-nav a {
  transition: none;
}
.dropdown-content ul li:hover,
.dropdown-footer ul li:hover a {
  background-color: #eee;
  color: #2e2e2e;
  outline: 0;
  text-decoration: none;
}
.dropdown-input-field:focus {
  color: #555;
  border-color: #73afea;
  box-shadow: 0 0 4px rgba(115, 175, 234, 0.4);
}

.dropdown-title {
  position: relative;
  padding: 8px 12px;
  padding-bottom: 16px;
  margin-bottom: 8px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px solid #dfdfdf;
  overflow: hidden;
}

.dropdown-title-button {
  position: absolute;
  top: 0;
  padding: 0;
  color: #bfbfbf;
  font-size: 14px;
  border: 0;
  background: none;
  outline: 0;
  margin: 10px 0px 0px 40%;
}

.form-goback-title-button {
  position: absolute;
  top: 0;
  padding: 0;
  color: #bfbfbf;
  font-size: 14px;
  border: 0;
  background: none;
  outline: 0;
}

.form-close-title-button {
  position: absolute;
  top: 0;
  padding: 0;
  color: #bfbfbf;
  font-size: 14px;
  border: 0;
  background: none;
  outline: 0;
}

.dropdown-menu-close {
  right: 5px;
  width: 20px;
  height: 20px;
  top: -1px;
}

.dropdown-menu-back {
  left: 7px;
  top: 2px;
}

.dropdown-labels-error {
  padding: 5px 10px;
  margin-bottom: 10px;
  background-color: #db3b21;
  color: #fff;
  width: 95%;
  margin-right: auto;
  margin-left: auto;
  min-height: 30px;
  padding: 0px 7px;
}

label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  right: 5px;
  top: 0px;
}
table th, td {
  white-space: nowrap;
}
</style>




// WEBPACK FOOTER //
// src/components/SelectOptionPackage.vue